import React, { useState, useEffect } from "react";
import { Chip, useTheme } from "@mui/material";
import {
  formatStatusLabel,
  getStatusChipBackgroundColor,
  getStatusChipForegroundColor,
  getStatusTokenFromRaw,
  normalizeStatusKey,
} from "app/utils/statusMapper";

interface CellChipStatusProps {
  /** any value; will be converted to string */
  children: any;
}

const CellChipStatus: React.FC<CellChipStatusProps> = ({ children }) => {
  const theme = useTheme();
  const [runningText, setRunningText] = useState("Running");

  const rawValue = String(children);
  const key = normalizeStatusKey(rawValue);
  const normalizedKey = getStatusTokenFromRaw(rawValue);
  const backgroundColor = getStatusChipBackgroundColor(theme, rawValue);
  const formattedLabel = key === 'RUNNING' ? runningText : formatStatusLabel(key);
  const textColor = getStatusChipForegroundColor(theme, rawValue);

  useEffect(() => {
    if (normalizedKey === 'RUNNING' && key === 'RUNNING') {
      const runningStates = ["Running", "Running.", "Running..", "Running..."];
      let currentIndex = 0;

      const interval = setInterval(() => {
        currentIndex = (currentIndex + 1) % runningStates.length;
        setRunningText(runningStates[currentIndex]);
      }, 500);

      return () => clearInterval(interval);
    }
  }, [key, normalizedKey]);

  return (
    <Chip
      label={formattedLabel}
      size="small"
      sx={{
        backgroundColor,
        color: textColor,
        fontWeight: 500,
        ...(normalizedKey === 'RUNNING' && key === 'RUNNING' && {
          color: `${theme.palette.common.white} !important`,
          minWidth: '85px',
          width: 'auto',
          justifyContent: 'flex-start',
          '& .MuiChip-label': {
            textAlign: 'left',
            justifyContent: 'flex-start',
            paddingLeft: '12px',
            paddingRight: '12px',
          }
        })
      }}
    />
  );
};

export default CellChipStatus;
